'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;
    this.$stateParams = $stateParams;

    this.cert = {};
  }

  $onInit() {
    this.getCert(this.$stateParams.id);
  }

  getCert(id) {
    this.$http.get(`/api/DeviceCerts/${id}`).then(res => {
      this.cert = res.data;
    });
  }

  upload(file) {
    if (!file) {
      this.update()
      return
    }
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/DeviceCerts/uploadFile',
      file: file,
      data: this.cert,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.$state.go('devicecert');
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  update() {
    this.$http.put(`/api/DeviceCerts/${this.$stateParams.id}`, this.cert).then(res => {
      this.$state.go('devicecert');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/devicecert/edit/edit.controller.js